import React from 'react';
import ViewPaymentSettingComponent from '../../../Components/PaymentSetting/ViewPaymentSetting';

export default function ViewPaymentSetting() {
    return (
        <div className='page-body'>
            <ViewPaymentSettingComponent />
        </div>
    );
}